
export interface ScopeSequenceTab {
  id: ScopeSequenceTabs;
  isAvailable: boolean;
  displayName: string;
}

export enum ScopeSequenceTabs {
  Core = 'core',
  Prerequisite = 'prerequisite',
  Enrichment = 'enrichment'
}
